<template>
	<div class="flex_1 margin_horizontal">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<template v-if="activeTab === tabTypes.ratings">
			<div class="table_description table_description_filter">
				<div class="tertiary_color text_left">
					{{ $t("customRating.table.headTip") }}
				</div>
			</div>
			<div class="table_head table_head_filter">
				<div class="flex flex_between">
					<md-button class="md-blank margin_r" @click="showDisplaySettingModal(true)">
						<i class="fa fa-cogs btn_icon" aria-hidden="true"></i>
						{{ $t("customRating.table.displaySetting") }}
					</md-button>
				</div>
			</div>
			<CustomRatingTableWithFilter/>
		</template>
		<CustomRatingDisplaySettingModal v-if="displaySettingModalShown"
										 @close="showDisplaySettingModal(false)"
										 @submit="confirmSubmitDisplaySetting"/>
	</div>
</template>

<script>
import CustomRatingTableWithFilter from "@/components/templates/investor/customRating/CustomRatingTableWithFilter";
import CustomRatingDisplaySettingModal
	from "@/components/templates/investor/customRating/CustomRatingDisplaySettingModal";
import {customRatingsApi} from "@/common/api/customRatingsApi";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
	components: { CustomRatingDisplaySettingModal, CustomRatingTableWithFilter, AccessRestrictedTabs },
	data() {
		let tabTypes = {
			ratings: {
				name: navigationTabs.investor.ratings.custom,
				translationKey: "customRating.tab.ratings",
				permission: enumDef.permissions.InvestorCustomRatings
			}
		};

		return {
			tabTypes: tabTypes,
			activeTab: null,
			displaySettingModalShown: false
		};
	},
	methods: {
		showDisplaySettingModal(show) {
			this.displaySettingModalShown = show;
		},
		confirmSubmitDisplaySetting(data) {
			let option = {
				title: this.$t("customRating.table.displaySetting.confirm.title"),
				msg: this.$t("customRating.table.displaySetting.confirm.msg"),
				confirmFun: this.submitDisplaySetting,
				params: data
			};
			this.confirmMeg(option, true);
		},
		submitDisplaySetting(data) {
			customRatingsApi.operation.saveConfig(data)
			.then(() => {
				this.showDisplaySettingModal(false);
				this.toastSuccess();
			})
			.catch(e => {
				this.toast(e);
			});
		}
	},
};
</script>